import { Box } from "@chakra-ui/react";
import { Lottie } from "src/components/Lottie";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar/CorrespondingAvatar";
import getAnimationData from "src/utils/getAnimationData";

export function AvatarProfile({ avatar, includeZzz = false }) {
  return (
    <Box pos="relative">
      <CorrespondingAvatar mx="auto" avatar={avatar} width="172px" />
      {includeZzz && (
        <Lottie
          zIndex={90}
          position="absolute"
          top="7px"
          right="0px"
          width="62px"
          transform="translateX(40%)"
          animationData={getAnimationData("zzz-small.json")}
        />
      )}
    </Box>
  );
}

export function SmallAvatarSleeping({ syncAnim, avatarSize, avatar }) {
  return (
    <Box position="relative">
      <Lottie
        animationData={getAnimationData("zzz-small.json")}
        getAnimControls={(controls) => syncAnim(controls)}
        zIndex={9000}
        position="absolute"
        top="4px"
        right="0px"
        width="37px"
        transform="translateX(40%)"
      />
      <CorrespondingAvatar
        width={avatarSize}
        height={avatarSize}
        avatar={avatar}
      />
    </Box>
  );
}
